import React, { useState, useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import DecisionAlertCard from "../DecisionAlertCard";

export const SURGERY_MODE_INTRO_DISMISSED_KEY = "surgeryModeIntroDismissed";

export function isSurgeryModeIntroDismissed() {
    return (
        window.localStorage.getItem(SURGERY_MODE_INTRO_DISMISSED_KEY) === "true"
    );
}

function SurgeryModeConfirmModal({ show, onConfirm, onCancel }) {
    const [dontShowAgain, setDontShowAgain] = useState(false);

    // Reset the checkbox each time the dialog is opened
    useEffect(() => {
        if (show) {
            setDontShowAgain(false);
        }
    }, [show]);

    const handleConfirm = () => {
        if (dontShowAgain) {
            window.localStorage.setItem(
                SURGERY_MODE_INTRO_DISMISSED_KEY,
                "true"
            );
        }
        onConfirm();
    };

    if (!show) {
        return null;
    }

    return (
        <div className="fixed top-0 z-50 h-full w-full bg-black/50">
            <DecisionAlertCard
                id="surgery-mode-confirm-modal"
                singleBtn={true}
                yesBtnTxt="Continue"
                yesBtnCallback={handleConfirm}
                noBtnCallback={onCancel}
            >
                <div className="px-6 pt-6 text-white">
                    <div className="mb-4 text-2xl font-medium">
                        Surgery Mode
                    </div>
                    <ul className="mb-4 list-disc space-y-2 pl-3">
                        <li>3D View will be maximized</li>
                        <li>
                            The default orientation will be coronal, with axes
                            rotated for consistency with the perspective of an
                            abdominal laparoscopic camera looking down at the
                            prostate.
                        </li>
                        <li>
                            The Capsule Risk Score will be displayed with
                            Left/Right axes flipped
                        </li>
                        <li>Auto-logout will be disabled</li>
                    </ul>
                    <div className="flex items-center justify-center">
                        <input
                            id="surgery-mode-dont-show-checkbox"
                            className="mr-2 w-4 cursor-pointer"
                            type="checkbox"
                            checked={dontShowAgain}
                            onChange={(e) => setDontShowAgain(e.target.checked)}
                            aria-label="Don't show this again"
                        />
                        <label
                            className="mb-0"
                            htmlFor="surgery-mode-dont-show-checkbox"
                        >
                            Don't show this again
                        </label>
                    </div>
                </div>
            </DecisionAlertCard>
        </div>
    );
}

SurgeryModeConfirmModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onConfirm: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
};

export default SurgeryModeConfirmModal;
